if(window.innerWidth > 991){
  var ZommAllClass = document.querySelectorAll(".cus_pro_zoom");
  var ZoomCloseBtn = document.querySelectorAll(".product-zoom-close")
  ZommAllClass.forEach(function(evt){
    evt.addEventListener("click",function(){
      document.body.classList.add("zoom-active");
      this.parentElement.parentElement.classList.add("active");
    })
  })
  
   document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
       //if esc key was not pressed in combination with ctrl or alt or shift
          const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
          if (isNotCombinedKey) {
            document.body.classList.remove("zoom-active");
            ZommAllClass.forEach(function(evt){
              evt.parentElement.parentElement.classList.remove("active");
            });
          }
        }
    });
  ZoomCloseBtn.forEach(function(evtn){
    evtn.addEventListener("click",function(){
      document.body.classList.remove("zoom-active");
      this.parentElement.parentElement.classList.remove("active");
    })
  })
}